import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';

import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';

import Collapse from '@material-ui/core/Collapse';

import { MdKeyboardReturn } from 'react-icons/md';
import { Tooltip } from 'components';

const styles = {
  iconTextExtras: {
    '&:hover': {
      color: '#2196f3',
    },
  },
  iconTextExtrasHost: {
    '&:hover': {
      color: '#f5830a',
    },
  },
  displayOff: { display: 'none' },
  displayOn: { display: 'block' },
  smallTableCell: { padding: '0px 0px 0px 4px' },
  tableBorder: { width: '94%', margin: '0px 3%' },
  collapseStyle: { width: '100%' },
};

const checkTheme = theme => {
  if (theme && theme === 'host') {
    return 'iconTextExtrasHost';
  }
  return 'iconTextExtras';
};

class FadeInOutComponent extends Component {
  render() {
    const { visibility, body } = this.props;
    return <Collapse in={visibility}>{body}</Collapse>;
  }
}

class TooltipComponent extends Component {
  render() {
    const { title, placement, tooltipBody } = this.props;
    return (
      <Tooltip title={title} placement={placement}>
        {tooltipBody}
      </Tooltip>
    );
  }
}

class IconBtnComponent extends Component {
  render() {
    const {
      classes,
      parentClasses,
      clickEvent,
      disabled,
      title,
      placement,
      icon,
      color,
      theme,
      style,
    } = this.props;

    const disabledValue = disabled === undefined || disabled === null ? false : disabled;

    return (
      <IconButton
        className={
          classes[checkTheme(theme)] +
          (parentClasses && parentClasses.iconBtn ? ' ' + parentClasses.iconBtn : '')
        }
        disabled={disabledValue}
        color={color}
        onClick={clickEvent}
        style={{ ...style, outline: 'none' }}
      >
        <RenderTooltip title={title} placement={placement} tooltipBody={icon} />
      </IconButton>
    );
  }
}

class IconBtnRedirectComponent extends Component {
  render() {
    const {
      classes,
      redirectEvent,
      disabled,
      title,
      placement,
      icon,
      component,
      color,
      theme,
    } = this.props;

    const disabledValue = disabled === undefined || disabled === null ? false : disabled;

    return (
      <IconButton
        className={classes[checkTheme(theme)]}
        disabled={disabledValue}
        color={color}
        component={component}
        to={redirectEvent}
        style={{ outline: 'none' }}
      >
        <RenderTooltip title={title} placement={placement} tooltipBody={icon} />
      </IconButton>
    );
  }
}

class PopoverComponent extends Component {
  render() {
    const { classes, openPopover, anchorEl, position, onClose, popoverBody } = this.props;
    return (
      <Popover
        className={openPopover ? classes.displayOn : classes.displayOff}
        open={openPopover}
        anchorEl={anchorEl}
        placement={position}
        onClose={onClose}
      >
        {popoverBody}
      </Popover>
    );
  }
}

class TextFieldComponent extends Component {
  render() {
    const { classes, id, label, onChange, onKeyDown, value, textMessage, onClick } =
      this.props;

    return (
      <TextField
        id={id}
        style={{
          zIndex: 0,
        }}
        label={label}
        onChange={onChange}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            onKeyDown();
          }
        }}
        value={value}
        margin="dense"
        variant="outlined"
        className={classes.textField}
        data-emojiable="true"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                disabled={
                  textMessage === null ||
                  textMessage === undefined ||
                  textMessage.trim() === ''
                }
                color="primary"
                edge="end"
                onClick={onClick}
                style={{ outline: 'none' }}
              >
                <MdKeyboardReturn />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
}

class TableComponent extends Component {
  renderHeadTableCell(orderBy, field, id, updateOrder) {
    const { classes, hasSearchField, searchField } = this.props;

    return (
      <TableCell key={id} className={classes.smallTableCell}>
        <TableSortLabel
          active={orderBy === `-${field.name}` || orderBy === field.name}
          direction={orderBy === `-${field.name}` ? 'desc' : 'asc'}
          onClick={() => {
            if (hasSearchField) {
              updateOrder(field.name, searchField);
            } else {
              updateOrder(field.name);
            }
          }}
        >
          {field.title}
        </TableSortLabel>
      </TableCell>
    );
  }

  renderHeadTableCellDefault(field, id) {
    const { classes } = this.props;
    return (
      <TableCell key={id} className={classes.smallTableCell}>
        {field.title}
      </TableCell>
    );
  }

  render() {
    const {
      classes,
      HeadList,
      orderBy,
      updateOrder,
      hasOptions,
      count,
      rowsPerPage,
      page,
      onChangePage,
      onChangeRowsPerPage,
      tableBodyContent,
    } = this.props;

    return (
      <React.Fragment>
        <Table className={classes.tableBorder}>
          <TableHead>
            <TableRow>
              {HeadList.map((row, id) => {
                if (row.name && row.name !== '') {
                  return this.renderHeadTableCell(orderBy, row, id, updateOrder);
                } else {
                  return this.renderHeadTableCellDefault(row, id);
                }
              })}
              {hasOptions ? (
                <TableCell className={classes.smallTableCell}>Options</TableCell>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>{tableBodyContent}</TableBody>
        </Table>
        <TablePagination
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </React.Fragment>
    );
  }
}

const RenderIconButton = withStyles(styles)(IconBtnComponent);
const RenderIconButtonRedirect = withStyles(styles)(IconBtnRedirectComponent);

const RenderPopover = withStyles(styles)(PopoverComponent);
const RenderTextField = withStyles(styles)(TextFieldComponent);
const RenderTable = withStyles(styles)(TableComponent);

const RenderTooltip = withStyles(styles)(TooltipComponent);
const RenderFadeInOut = withStyles(styles)(FadeInOutComponent);

export {
  RenderIconButton,
  RenderIconButtonRedirect,
  RenderPopover,
  RenderTextField,
  RenderTable,
  RenderTooltip,
  RenderFadeInOut,
};
